export const TableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'definition', label: 'Codes' },
  { key: 'descriptionHtml', label: 'Description' },
];
